<script lang="ts">
  import TextNew, { type TextSize } from "../TextNew.svelte";

  export let title: string | undefined = undefined;
  export let subtitle: string | undefined = undefined;
  export let textSize: TextSize | undefined = "s";
  export let textColor: string | undefined = "var(--rekki-light)";
  export let subtitleColor: string | undefined = textColor;
  export let x: number = 0;
  export let y: number = 0;
  export let offset: { x: number; y: number } = { x: 16, y: 32 };
</script>

{#if title}
  <div
    class="box"
    style="
          top: {y + offset.y}px;
          left: {x + offset.x}px;"
  >
    <TextNew size={textSize} --rk-text-color={textColor}>{title}</TextNew>
    {#if subtitle}
      <div class="subtitle">
        <TextNew size={textSize} --rk-text-color={subtitleColor}>{subtitle}</TextNew>
      </div>
    {/if}
  </div>
{/if}

<style>
  .box {
    position: absolute;
    border-radius: var(--rk-rounding-m);
    background-color: var(--rk-divider-4);
    color: var(--rekki-transparency-light);
    padding: 12px 16px;
    z-index: 99;
  }
  .subtitle {
    margin-top: 4px;
  }
</style>
